import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    overflowY: 'auto'
  },
  paper: {
    backgroundColor: darken(theme.palette.background.paper, 0.2),
    margin: 'auto',
    width: '50%',
    maxWidth: 700,
    overflowY: 'auto',
    overflowX: 'auto',
    padding: 24,
    marginTop: '15vh',
    marginBottom: '10vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  }
}))
export default useStyles
